export enum ApplicationStatus {
  LEAD_RESERVED = 'LEAD_RESERVED',
  LEAD_PENDING = 'LEAD_PENDING',
  VERIFIED = 'VERIFIED',
  VEHICLE_INFO_PROVIDED = 'VEHICLE_INFO_PROVIDED',
  BASIC_INFO_PROVIDED = 'BASIC_INFO_PROVIDED',
  COMPLETED_INFO = 'COMPLETED_INFO',
  USER_CONFIRMED = 'USER_CONFIRMED',
  APPROVED = 'APPROVED',
  SURVEY = 'SURVEY',
  DISBURSED = 'DISBURSED',
  REJECTED = 'REJECTED',
  REJECTED_BLACKLIST_AREA = 'REJECTED_BLACKLIST_AREA',
  SUBMITTED_SALESTRAX = 'SUBMITTED_SALESTRAX',
  CANCEL = 'CANCEL',
  LEAD_EXPIRED = 'LEAD_EXPIRED',
  APPROVAL_IN_PROGRESS = 'APPROVAL_IN_PROGRESS',
  READY_FOR_GOLIVE = 'READY_FOR_GOLIVE',
  GO_LIVE = 'GO_LIVE',
  DONE_GO_LIVE = 'DONE_GO_LIVE',
}

export enum SurveyTypes {
  BRANCH_VISIT = 'WALKIN',
  HOME_VISIT = 'SURVEY',
}

export enum RiskCategories {
  VERY_HIGH = 'VERY_HIGH_RISK',
  HIGH = 'HIGH_RISK',
  MEDIUM = 'MEDIUM_RISK',
  LOW = 'LOW_RISK',
  VERY_LOW = 'VERY_LOW_RISK',
  UNCLASSIFIED = 'UNCLASSIFIED',
}

export enum ApplicationType {
  BRAVO = 'BRAVO',
  DIGITAL = 'DIGITAL',
  EGC = 'EGC',
}

export enum LoanProcessor {
  BRAVO = 'BRAVO_LOS',
  SALESTRAX = 'SALESTRAX',
  CONFINS = 'CONFINS',
}
